import { ChangeDetectionStrategy, Component, computed, effect, input, Input, InputSignal, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { Subject } from 'rxjs';
import { SpinnerComponent } from 'shared-library';

@Component({
  selector: 'app-tree-map-chart',
  imports: [NgApexchartsModule, SpinnerComponent,TranslatePipe],
  templateUrl: './tree-map-chart.component.html',
  styleUrl: './tree-map-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeMapChartComponent implements OnInit {
  readonly cssClass = input<string>('');
  readonly chartCase = input<string>('');
  readonly data: InputSignal<{ category: string; grossAmount: number }[]> = input.required();


  @Input() graphColors: string = '';

  // chartOptions: any = {};
  colors: string[] = [];

  readonly chartOptions = computed<TreeChartOptions>(() => {
    const data = this.data();
    const colorsArray = this.getColors();

    return {
      series: [
        {
          data: data.map((item) => {

            return {
              x: item.category,
              y: item.grossAmount,
            };
          }),
        },
      ],
      chart: {
        width: '100%',
        height: 300,
        type: 'treemap',

        events: {
          dataPointSelection: () => this.router.navigate(['/reports/healthcareProviders']),
        },
      },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: true,
          shadeIntensity: 0.2,
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
        },

        formatter: (text: string, opts: { value: number }) => {
          return `${text} (${fmt(opts.value)})`;
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      colors: colorsArray,
      yaxis: {
        labels: {
          show: true,
        },
      },
      tooltip: {
        y: {
          formatter: (val: number) => fmt(val),
        },
      },
    } as TreeChartOptions;
  });

  isLoading = computed(() => this.data()?.length === 0)

  constructor(
    private router: Router
  ) {

  }
  ngOnInit(): void { }


  get hasChartData(): boolean {
    const series = this.chartOptions()?.series;
    if (!series) return false;

    if (Array.isArray(series) && series.length > 0 && typeof series[0] === 'number') {
      return series.some((n: any) => Number(n) > 0);
    }

    if (Array.isArray(series)) {
      return series.some((s: any) => {
        if (Array.isArray(s.data)) {
          return s.data.some((item: any) => this.isPositiveItem(item));
        }
        return this.arrayHasPositiveValue(series);
      });
    }

    return false;
  }

  private arrayHasPositiveValue(arr: any[]): boolean {
    if (!Array.isArray(arr) || arr.length === 0) return false;
    return arr.some(item => this.isPositiveItem(item));
  }

  private isPositiveItem(item: any): boolean {
    if (item == null) return false;

    if (typeof item === 'number') return item > 0;
    if (typeof item === 'string') return Number(item) > 0;

    if (typeof item === 'object') {
      const keysToCheck = ['y', 'value', 'amount', 'grossAmount', 'claimVolume', 'totalClaims'];
      for (const k of keysToCheck) {
        if (k in item && !isNaN(Number(item[k])) && Number(item[k]) > 0) return true;
      }

      for (const k of Object.keys(item)) {
        const num = Number((item as any)[k]);
        if (!isNaN(num) && num > 0) return true;
      }
    }

    return false;
  }

  ngOnDestroy(): void { }

  getColors(color: string = '') {
    if (color == '') {
      return [
        '#4B49AC',
        '#98BDFF',
        '#7DA0FA',
        '#7978E9',
        '#125773',
        '#27CDF2',
        '#488A99',
        '#C6D936',
      ];
    } else return [color];
  }

}
export function fmt(val: number) {
  if (val / 1000 > 1) {
    return val.toLocaleString() + '€';
  } else if (val < 100) {
    return val + 'M';
  } else {
    return val.toLocaleString() + 'M';
  }
};


export interface TreeChartOptions {
  series: ChartSeries[];
  chart: {
    width: string;
    height: number;
    type: 'treemap';
    events: {
      dataPointSelection: () => void;
    };
  };
  plotOptions: unknown;
  dataLabels: unknown;
  stroke: unknown;
  colors: string[];
  yaxis: unknown;
  tooltip: unknown;
}

export interface ChartSeriesData {
  x: string;
  y: number;
}

export interface ChartSeries {
  data: ChartSeriesData[];
}